<template>
  <b-container fluid>
    <div class="iq-card mt-3">
      <div class="iq-card-header d-flex justify-content-between">
        <div class="iq-header-title my-2">
          <h4 class="card-title">
            {{ massName ? massName : 'All Asset' }} Device List
          </h4>
        </div>
        <b-row>
          <b-col md="12">
            <div class="text-right">
              <b-button
                class="mr-2"
                size="sm"
                variant="secondary"
                @click="openDuplicateModal"
              >
                <i class="ri-file-copy-line"></i>
                Duplicate Devices
              </b-button>
              <button-options
                :access="'master_device'"
                :hideAdd="false"
                :hideDetail="true"
                :isRefreshEnabled="true"
                :isRefreshed="isRefreshed"
                @onAddItemClicked="openAddForm"
                @onRefreshed="getData('Refreshed')"
              />
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="iq-card-body">
        <b-row class="mb-3">
          <b-col md="4" v-if="!massId">
            <label>Filter Asset:</label>
            <input-selector
              :data="assets"
              :id="'massId'"
              :label="'massName'"
              :loading="isLoading"
              :placeholder="'Please select asset'"
              v-model="deviceFilter.devcMassId"
            />
          </b-col>
          <b-col md="3">
            <label>Filter Device Type:</label>
            <input-selector
              :data="devcTypes"
              :id="'value'"
              :label="'name'"
              :loading="isLoading"
              :placeholder="'Please select device type'"
              v-model="deviceFilter.devcType"
              @onChangeSelector="onChangeDeviceType"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <device-list
              :access="'master_device'"
              :data="data"
              :loading="isLoading"
              :pagination="pagination"
              @onActionDelete="openDelete"
              @onActionEdit="openEdit"
              @onActionDuplicate="openDuplicateForm"
              @onPageChanged="onPageChanged"
              @update="onUpdated"
            />
          </b-col>
        </b-row>
      </div>
      <b-modal
        size="lg"
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
        v-model="displayForm"
      >
        <device-form
          :data="currentDevice"
          :errors="errors"
          :isSubmit="isSubmit"
          :isClone="isClone"
          @onSubmitClicked="onSubmitClicked"
          @onCancelAddClicked="onCancel"
        />
      </b-modal>
      <b-modal
        size="lg"
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
        v-model="displayDeletion"
      >
        <DeleteItem
          :isSubmit="isSubmit"
          @onCancelDeletion="displayDeletion = false"
          @onConfirmDeletion="onConfirmDeletion"
        />
      </b-modal>
      <b-modal
        size="lg"
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
        v-model="displayDuplicate"
      >
        <div class="iq-card mb-0">
          <div class="iq-card-header">
            <h5 class="card-title mb-0">Duplicate Devices</h5>
          </div>
          <div class="iq-card-body">
            <b-row>
              <b-col md="6">
                <label>Source Company:</label>
                <input-selector
                  :data="availableCompanies"
                  :id="'compId'"
                  :label="'compName'"
                  :loading="duplicateState.isLoading"
                  :placeholder="'Select source company'"
                  v-model="duplicateState.sourceCompanyId"
                />
              </b-col>
              <b-col md="6">
                <label>Target Company:</label>
                <input-selector
                  :data="availableCompanies"
                  :id="'compId'"
                  :label="'compName'"
                  :loading="duplicateState.isLoading"
                  :placeholder="'Select target company'"
                  v-model="duplicateState.targetCompanyId"
                />
              </b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col md="6">
                <label>Source Asset:</label>
                <input-selector
                  :data="duplicateState.sourceAssets"
                  :id="'massId'"
                  :label="'massName'"
                  :loading="duplicateState.isLoading"
                  :placeholder="'Select source asset'"
                  v-model="duplicateState.sourceAssetId"
                />
              </b-col>
              <b-col md="6">
                <label>Target Asset:</label>
                <input-selector
                  :data="duplicateState.targetAssets"
                  :id="'massId'"
                  :label="'massName'"
                  :loading="duplicateState.isLoading"
                  :placeholder="'Select target asset'"
                  v-model="duplicateState.targetAssetId"
                />
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col md="12">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <label class="mb-0">Devices to duplicate:</label>
                  <b-form-checkbox
                    v-model="duplicateState.selectAll"
                    @change="onToggleSelectAll"
                  >
                    Select all
                  </b-form-checkbox>
                </div>
                <b-table
                  small
                  responsive
                  :busy="duplicateState.isLoading"
                  :items="duplicateDevices"
                  :fields="duplicateFields"
                  show-empty
                >
                  <template v-slot:cell(selected)="data">
                    <b-form-checkbox
                      :value="data.item.devcId"
                      v-model="duplicateState.selectedIds"
                    ></b-form-checkbox>
                  </template>
                  <template v-slot:cell(devcName)="data">
                    <b-form-input
                      v-model="data.item.devcName"
                      size="sm"
                      placeholder="Device name"
                    ></b-form-input>
                  </template>
                  <template v-slot:cell(devcLabel)="data">
                    <b-form-input
                      v-model="data.item.devcLabel"
                      size="sm"
                      placeholder="Label"
                    ></b-form-input>
                  </template>
                  <template v-slot:cell(devcUniqueId)="data">
                    <b-form-input
                      v-model="data.item.devcUniqueId"
                      size="sm"
                      placeholder="Unique ID"
                    ></b-form-input>
                  </template>
                  <template v-slot:table-busy="">
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div>
                  </template>
                </b-table>
              </b-col>
            </b-row>

            <b-row class="mt-2" v-if="duplicateState.conflicts.length > 0">
              <b-col md="12">
                <div class="alert alert-warning mb-0">
                  Found duplicate Unique ID in target asset. Please deselect or allow overwrite.
                  <div class="mt-2">
                    <strong>Conflicts:</strong>
                    <span v-for="(id, index) in duplicateState.conflicts" :key="id">
                      {{ id }}<span v-if="index < duplicateState.conflicts.length - 1">, </span>
                    </span>
                  </div>
                  <div class="mt-2">
                    <b-form-checkbox v-model="duplicateState.allowOverwrite">
                      Allow overwrite on conflicts
                    </b-form-checkbox>
                  </div>
                </div>
              </b-col>
            </b-row>

            <div class="form-group mt-4">
              <b-button
                class="mr-1"
                size="sm"
                variant="outline-danger"
                :disabled="duplicateState.isSubmitting"
                @click="closeDuplicateModal"
              >
                <div class="mx-2">Cancel</div>
              </b-button>
              <b-button
                size="sm"
                variant="primary"
                class="ml-1"
                :disabled="duplicateState.isSubmitting"
                @click="onDuplicateSubmit"
              >
                <div class="mx-2">
                  <i v-if="duplicateState.isSubmitting" class="ri-loader-line"></i>
                  Duplicate
                </div>
              </b-button>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </b-container>
</template>

<script>
import DeviceForm from '@/components/device/Form.vue';
import DeviceList from '@/components/device/List.vue';
import DeviceSvc from '@/services/DeviceSvc';
import AuthSvc from '@/services/AuthSvc';

import ButtonOptions from '@/components/directives/button-options';
import DeleteItem from '@/components/directives/delete-item';
import InputSelector from '@/components/directives/input-selector';

import requestBuilder from '@/util/request.builder';
import AssetSvc from '@/services/AssetSvc';

export default {
  name: 'Device',
  components: {
    DeleteItem,
    InputSelector,
    ButtonOptions,
    DeviceForm,
    DeviceList,
  },
  data() {
    const massIdQuery = this.$route.query.massId;
    const parsedMassId = massIdQuery ? Number(massIdQuery) : null;
    return {
      massId: this.$route.params.id || null,
      massName: null,
      assets: [],
      currentDevice: {},
      data: [],
      devcTypes: [
        { name: 'GPS', value: 'gps' },
        { name: 'Flowmeter', value: 'flowmeter' },
        { name: 'RPM', value: 'rpm' },
        { name: 'Auxialary Engine', value: 'ae' },
        { name: 'Gateway', value: 'gateway' },
        { name: 'Power Supply', value: 'power' },
        { name: 'Powermeter', value: 'powermeter' },
        { name: 'Tank', value: 'tank' },
        { name: 'Temperature', value: 'temperature' },
        { name: 'Switch', value: 'limitswitch' },
      ],
      displayForm: false,
      displayDeletion: false,
      displayDuplicate: false,
      errors: {},
      deviceFilter: {
        devcMassId: Number.isNaN(parsedMassId) ? null : parsedMassId,
      },
      assetFilter: {
        massCompId: null,
      },
      isLoading: false,
      isRefreshed: false,
      isSubmit: false,
      isClone: false,
      duplicateState: {
        sourceCompanyId: null,
        targetCompanyId: null,
        sourceAssets: [],
        targetAssets: [],
        sourceAssetId: null,
        targetAssetId: null,
        devices: [],
        selectedIds: [],
        selectAll: false,
        conflicts: [],
        allowOverwrite: false,
        isLoading: false,
        isSubmitting: false,
      },
      pagination: {
        current: 1,
        pageSize: 25,
        totalSize: 0,
      },
    };
  },
  async created() {
    await this.getAssets();
  },
  watch: {
    'deviceFilter.devcMassId': {
      handler(massId) {
        this.$router.push({ query: { ...this.$route.query, massId: massId || undefined } }).catch(() => {});
        this.getData();
      },
      immediate: true,
    },
    'duplicateState.sourceAssetId': {
      async handler() {
        await this.loadDuplicateDevices();
      },
    },
    'duplicateState.sourceCompanyId': {
      async handler(companyId) {
        this.duplicateState.sourceAssetId = null;
        this.duplicateState.sourceAssets = [];
        this.duplicateState.devices = [];
        this.duplicateState.selectedIds = [];
        this.duplicateState.selectAll = false;
        this.duplicateState.conflicts = [];
        this.duplicateState.allowOverwrite = false;

        if (!companyId) return;
        await this.loadAssetsForCompany(companyId, 'sourceAssets');
      },
    },
    'duplicateState.targetCompanyId': {
      async handler(companyId) {
        this.duplicateState.targetAssetId = null;
        this.duplicateState.targetAssets = [];
        this.duplicateState.conflicts = [];
        this.duplicateState.allowOverwrite = false;

        if (!companyId) return;
        await this.loadAssetsForCompany(companyId, 'targetAssets');
      },
    },
    'duplicateState.selectedIds': {
      handler(selected) {
        const total = this.duplicateState.devices.length;
        this.duplicateState.selectAll = total > 0 && selected.length === total;
      },
    },
  },
  computed: {
    availableCompanies() {
      const companies = this.$store.getters['auth/availableCompany'] || {};
      return Object.values(companies);
    },
    duplicateDevices() {
      return this.duplicateState.devices;
    },
    duplicateFields() {
      return [
        { key: 'selected', label: '' },
        { key: 'devcName', label: 'Device Name' },
        { key: 'devcType', label: 'Device Type' },
        { key: 'devcLabel', label: 'Label' },
        { key: 'devcUniqueId', label: 'Unique ID' },
      ];
    },
  },
  methods: {
    async withCompany(companyId, task) {
      const activeCompany = this.$store.getters['auth/activeCompany'];
      const originalId = activeCompany ? activeCompany.compId : null;
      const shouldSwitch = companyId && originalId && originalId !== companyId;

      if (shouldSwitch) {
        await AuthSvc.setCompany(companyId);
      }

      try {
        return await task();
      } finally {
        if (shouldSwitch) {
          await AuthSvc.setCompany(originalId);
        }
      }
    },
    async loadAssetsForCompany(companyId, targetKey) {
      this.duplicateState.isLoading = true;
      try {
        const assetResponse = await this.withCompany(companyId, () => AssetSvc.getAssets({
          params: {
            ...requestBuilder.buildFilters(this.pagination, this.assetFilter),
          },
        }));
        this.duplicateState[targetKey] = assetResponse.data.data.map((asset) => ({
          massId: asset.massId,
          massName: asset.massName,
        }));
      } catch (e) {
        this.$toast.error('Failed to load assets for selected company');
      } finally {
        this.duplicateState.isLoading = false;
      }
    },
    async getAssets() {
      const assetResponse = await AssetSvc.getAssets({
        params: {
          ...requestBuilder.buildFilters(this.pagination, this.assetFilter),
        },
      });
      this.assets = assetResponse.data.data.map((asset) => ({
        massId: asset.massId,
        massName: asset.massName,
      }));
    },
    async deleteData(notification, data) {
      this.isSubmit = true;
      try {
        const deviceDeleteResponse = await DeviceSvc.deleteDevice(data.devcId);
        if (deviceDeleteResponse.data.status.error === 0) {
          await this.$toast.success(notification);
          this.displayDeletion = await false;
          this.pagination.current = 1;
          this.getData();
        } else {
          this.$toast.error(deviceDeleteResponse.data.status.message);
        }
      } catch (e) {
        this.$toast.error(e.message);
      } finally {
        this.isSubmit = false;
      }
    },
    async getData(notification) {
      try {
        this.isLoading = true;
        this.isRefreshed = true;

        let deviceParams = {};

        // menambahkan params findField dan findValue jika ada parameter
        if (this.massId) {
          deviceParams = {
            'finds[devcMassId]': this.massId,
          };
        }

        const deviceResponse = await DeviceSvc.getDevices({
          params: {
            ...requestBuilder.buildFilters(this.pagination, this.deviceFilter),
            ...deviceParams,
          },
        });

        this.data = deviceResponse.data.data;
        this.pagination.totalSize = deviceResponse.data.pagination.totalData;

        if (notification) {
          this.$toast.success(notification);
        }
      } catch (e) {
        if (e.response.data) {
          if (e.response.data.status.message === 'Authentication Error') {
            this.doLogOut();
          } else {
            this.$toast.error(e.response.data.status.message);
          }
        } else {
          this.$toast.error('Network error');
        }
      } finally {
        this.isLoading = false;
        this.isRefreshed = false;
      }
    },
    async onSubmitClicked(form) {
      const data = {
        devcName: form.devcName,
        devcLabel: form.devcLabel,
        devcType: form.devcType,
        devcStatus: form.devcStatus,
        devcMassId: form.devcMassId,
        devcUniqueId: form.devcUniqueId,
      };
      this.errors = {};
      this.isSubmit = true;
      try {
        let response = {};
        if (form.devcId) {
          response = await DeviceSvc.updateDevice(data, form.devcId);
        } else {
          response = await DeviceSvc.addDevice(form);
        }
        if (response.data.status.error === 0) {
          await this.getData('Success');
          this.currentDevice = {};
          this.displayForm = false;
        } else {
          const errors = response.data.status.message;
          if (typeof errors === 'object') {
            this.errors = response.data.status.message;
            this.$toast.error('Error found');
          } else {
            this.$toast.error(response.data.status.message);
          }
        }
        this.isSubmit = false;
      } catch (e) {
        this.$toast.error(e.response.data.status.message);
        this.isSubmit = false;
      }
    },
    onCancel() {
      this.currentDevice = {};
      this.displayForm = false;
    },
    onConfirmDeletion() {
      this.deleteData('Deleted complete', this.selected);
    },
    onChangeDeviceType() {
      this.getData();
    },
    onPageChanged(page) {
      this.pagination.current = page;
      this.getData();
    },
    onUpdated() {
      this.getData('Updated');
    },
    openAddForm() {
      this.isClone = false;
      this.currentDevice = {};
      this.displayForm = true;
    },
    openDelete(data) {
      this.displayDeletion = true;
      this.selected = data;
    },
    openEdit(data) {
      this.isClone = false;
      this.displayForm = true;
      this.currentDevice = {
        ...this._.find(this.data, (v) => v.devcId === data.devcId),
      };
    },
    openDuplicateForm(data) {
      this.isClone = true;
      this.currentDevice = {
        ...this._.find(this.data, (v) => v.devcId === data.devcId),
      };
      this.currentDevice.devcId = null;
      this.displayForm = true;
    },
    openDuplicateModal() {
      const activeCompany = this.$store.getters['auth/activeCompany'];
      const activeCompanyId = activeCompany ? activeCompany.compId : null;
      this.displayDuplicate = true;
      this.duplicateState = {
        sourceCompanyId: activeCompanyId,
        targetCompanyId: activeCompanyId,
        sourceAssets: [],
        targetAssets: [],
        sourceAssetId: null,
        targetAssetId: null,
        devices: [],
        selectedIds: [],
        selectAll: false,
        conflicts: [],
        allowOverwrite: false,
        isLoading: false,
        isSubmitting: false,
      };
    },
    closeDuplicateModal() {
      this.displayDuplicate = false;
    },
    async loadDuplicateDevices() {
      this.duplicateState.devices = [];
      this.duplicateState.selectedIds = [];
      this.duplicateState.selectAll = false;
      this.duplicateState.conflicts = [];
      this.duplicateState.allowOverwrite = false;

      if (!this.duplicateState.sourceCompanyId || !this.duplicateState.sourceAssetId) return;

      this.duplicateState.isLoading = true;
      try {
        const resp = await this.withCompany(this.duplicateState.sourceCompanyId, () => DeviceSvc.getDeviceByMassId(this.duplicateState.sourceAssetId));
        this.duplicateState.devices = (resp.data.data || []).map((device) => ({
          ...device,
          devcName: device.devcName || '',
          devcLabel: device.devcLabel || '',
          devcUniqueId: device.devcUniqueId || '',
        }));
        this.duplicateState.selectedIds = this.duplicateState.devices.map(
          (device) => device.devcId,
        );
        this.duplicateState.selectAll = this.duplicateState.devices.length > 0;
      } catch (e) {
        this.$toast.error('Failed to load devices for source asset');
      } finally {
        this.duplicateState.isLoading = false;
      }
    },
    onToggleSelectAll(value) {
      if (value) {
        this.duplicateState.selectedIds = this.duplicateState.devices.map(
          (device) => device.devcId,
        );
      } else {
        this.duplicateState.selectedIds = [];
      }
    },
    async onDuplicateSubmit() {
      if (!this.duplicateState.sourceCompanyId) {
        this.$toast.warning('Please select source company');
        return;
      }
      if (!this.duplicateState.targetCompanyId) {
        this.$toast.warning('Please select target company');
        return;
      }
      if (!this.duplicateState.sourceAssetId) {
        this.$toast.warning('Please select source asset');
        return;
      }
      if (!this.duplicateState.targetAssetId) {
        this.$toast.warning('Please select target asset');
        return;
      }
      if (this.duplicateState.sourceAssetId === this.duplicateState.targetAssetId) {
        this.$toast.warning('Source and target asset must be different');
        return;
      }
      if (this.duplicateState.selectedIds.length === 0) {
        this.$toast.warning('Please select at least one device');
        return;
      }

      this.duplicateState.isSubmitting = true;
      this.duplicateState.conflicts = [];
      try {
        const selectedDevices = this.duplicateState.devices.filter((device) => this.duplicateState.selectedIds.includes(device.devcId));
        const missingUniqueId = selectedDevices.filter((device) => !device.devcUniqueId);
        if (missingUniqueId.length > 0) {
          this.$toast.warning('Please fill Unique ID for all selected devices');
          return;
        }

        // ponytail: duplicate Unique ID check disabled per request, always overwrite on conflict
        const targetResp = await this.withCompany(this.duplicateState.targetCompanyId, () => DeviceSvc.getDeviceByMassId(this.duplicateState.targetAssetId));
        const targetDevices = targetResp.data.data || [];
        const targetByUniqueId = {};
        targetDevices.forEach((device) => {
          if (device.devcUniqueId) {
            targetByUniqueId[device.devcUniqueId] = device;
          }
        });

        await this.withCompany(this.duplicateState.targetCompanyId, () => Promise.all(selectedDevices.map((device) => {
          const payload = {
            devcName: device.devcName,
            devcLabel: device.devcLabel,
            devcType: device.devcType,
            devcStatus: device.devcStatus,
            devcMassId: this.duplicateState.targetAssetId,
            devcUniqueId: device.devcUniqueId,
          };

          const existing = targetByUniqueId[device.devcUniqueId];
          if (existing) {
            return DeviceSvc.updateDevice(payload, existing.devcId);
          }
          return DeviceSvc.addDevice(payload);
        })));

        this.$toast.success('Duplicate devices completed');
        this.closeDuplicateModal();
      } catch (e) {
        this.$toast.error('Failed to duplicate devices');
      } finally {
        this.duplicateState.isSubmitting = false;
      }
    },
    doLogOut() {
      this.$toast.error('Please re-login');
      this.$store.dispatch('auth/logout');
      this.$router.replace({ name: 'Login' });
    },
  },
  mounted() {
    this.assetFilter.massCompId = Object.keys(
      this.$store.getters['auth/availableCompany'],
    );

    // mengambil data nama kapal berdasar massId
    if (this.massId) {
      const selectedAsset = this.assets.find(
        (asset) => asset.massId === parseInt(this.massId),
      );
      if (selectedAsset) {
        this.massName = selectedAsset.massName;
      }
    }
  },
};
</script>

<style scoped></style>
